/* eslint-disable no-magic-numbers */
import { getRel } from './utils/getRel';
import { scaleToCover } from './utils/scaleTo';

export default function ContestImage(texture) {
	// create the contest image
	const imgCont = new PIXI.Container();
	imgCont.position = getRel(0.5, 0);
	const img = new PIXI.Sprite(texture);
	scaleToCover(img, window.rendererWidth / 2, window.rendererHeight);
	const imgMask = new PIXI.Graphics();
	imgMask.beginFill(0x00FF00, 1);
	imgMask.drawRect(0, 0, (window.rendererWidth / 2), window.rendererHeight);
	imgCont.addChildAt(img, 0);
	imgCont.addChildAt(imgMask, 1);
	imgCont.mask = imgMask;

	return imgCont;
}
